import { css } from 'aphrodite';
import * as React from 'react';
import type { ISupportReportAgent } from '../../../../models/Support/ISupportReportOverview';
import { getInitials } from '../../../../utils/Support/supportHelpers';
import { Avatar } from '../../../../web/components-v2/Avatar';
import { formatCount, formatDurationMinutes } from './reportsPresentation';
import { reportsStyles as rs } from './styles/reportsStyles';

interface TopAgentsCardProps {
	agents: ISupportReportAgent[];
	profilePicMap: Record<string, string>;
	isLoading?: boolean;
}

export const TopAgentsCard: React.FC<TopAgentsCardProps> = ({ agents, profilePicMap, isLoading }) => (
	<section className={css(rs.card)}>
		<div className={css(rs.cardHeader)}>
			<div>
				<h2 className={css(rs.cardTitle)}>Top agents</h2>
				<div className={css(rs.cardSubtitle)}>by resolved</div>
			</div>
		</div>
		{isLoading ? (
			<div className={css(rs.chartLoading)}>Loading…</div>
		) : agents.length === 0 ? (
			<div className={css(rs.chartEmpty)}>No agent activity in this period.</div>
		) : (
			<ul className={css(rs.agentList)}>
				{agents.map(agent => (
					<li key={agent.agentId} className={css(rs.agentRow)}>
						<Avatar
							imgSrc={profilePicMap[agent.agentId]}
							altText={agent.agentName}
							fallbackText={getInitials(agent.agentName)}
							smallText
							styles={[rs.agentAvatar]}
						/>
						<div className={css(rs.agentInfo)}>
							<div className={css(rs.agentName)}>{agent.agentName}</div>
							<div className={css(rs.agentMeta)}>
								Median response {formatDurationMinutes(agent.medianFirstResponseMinutes)}
							</div>
						</div>
						<div className={css(rs.agentResolved)}>{formatCount(agent.closedCount)} resolved</div>
					</li>
				))}
			</ul>
		)}
	</section>
);
